module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAAAGCAYAAACl4YCPAAAAAXNSR0IArs4c6QAAAH1JREFUWEft2LENgCAQQNG7PWQzGicRFtHG0dzjDCQachobsPt2kEDxcj8k6hqDiftULM37kf0+awQQ+BbY4rSYaHo05UMjMkYJgT6Bt9i0DY3I+oA5jcAl4GO7QyMyhgSBsQJtbDU0IhsLzG0I+JdNS3X8+GAwEPhPoDR2AnvpMwulYp1QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/leftmenutop.png
// module id = dpJm
// module chunks = 1